<h1 mat-dialog-title>Confirmar pagamentos em demanda</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="max-width: '600px';">

    <div class="row">
        <div class="col-sm">
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Números dos pedidos</mat-label>
                <mat-chip-list #chipList aria-label="Fruit selection">
                    <mat-chip *ngFor="let numero of numerosPedidos" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(numero)">
                        {{numero}}
                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                    </mat-chip>
                    <input type="number" [min]="1" placeholder="Números dos pedidos..." #pedidosInput
                        [formControl]="numerosCtrl" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
                </mat-chip-list>
            </mat-form-field>
        </div>
    </div>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="confirmarPagamentos()" *ngIf="numerosPedidos.length > 0">
            <mat-icon>check</mat-icon> Confirmar pagamentos
        </button>
    </section>
</div>